import Posts from './app-posts'
export default Posts;